import { getLoggingLevelCookieName } from '@shared/logging/getLoggingLevelCookieName';
import { getValidatedBase64Cookie } from '@shared/cookies/getValidatedBase64Cookie';
import { consoleLogger } from '@shared/logging/consoleLogger';
import { createCookie } from '@shared/cookies/createCookie';
import { encodeToBase64 } from '@shared/conversion/encodeToBase64';
import { LogLevelType } from '@shared/content/types';

/**
 * Initializes the consoleLogger and logging level cookie statuses based on
 * the initial cookie or the Utiq.config.logLevel values
 * @param environment Current environment
 * @param prefix Specific module name to set in the logs prefix
 */
export const initializeConsoleLogger = (environment: string, prefix = '') => {
  const cookieName = getLoggingLevelCookieName();
  const cookieValue = <LogLevelType>(
    getValidatedBase64Cookie(document.cookie, cookieName)
  );
  const logLevelQueryParam = new URLSearchParams(window.location.search).get(
    'utiq_log_level',
  );
  let logLevel = window.Utiq?.config?.logLevel;
  if (logLevelQueryParam && logLevelQueryParam in consoleLogger.logLevels) {
    logLevel = logLevelQueryParam as LogLevelType;
    document.cookie = createCookie({
      name: cookieName,
      value: encodeToBase64(logLevel),
      days: 90,
    });
  } else if (cookieValue && cookieValue in consoleLogger.logLevels) {
    // Set the logging level based on the cookie value
    logLevel = cookieValue;
  } else if (logLevel && logLevel in consoleLogger.logLevels) {
    // Add the new cookie for the Utiq.config.logLevel value
    document.cookie = createCookie({
      name: cookieName,
      value: encodeToBase64(logLevel),
      days: 90,
    });
  } else {
    // Clear the cookie in case a wrong value is set and there is not Utiq.config.logLevel value
    document.cookie = createCookie({
      name: cookieName,
      value: encodeToBase64(),
      days: 0,
    });
  }
  consoleLogger.initialize(environment + prefix, logLevel);
  if (
    !window.Utiq?.isLogLevelInitialized &&
    logLevel &&
    cookieValue !== logLevel
  ) {
    // eslint-disable-next-line no-console
    console.info(
      consoleLogger.prefix,
      `Logging level (${logLevel}) has been initialized`,
    );
    window.Utiq ||= {};
    window.Utiq.isLogLevelInitialized = true;
  }
};
